import { axios as $http } from 'cm'
import monitor from 'src/frontend-lib/lib/monitor'
import APIS from 'src/pages/lesson/play/module/apis'

const statMonitor = stat => monitor && monitor.stat(stat)

// event state
const state = {
  learnTotalTime: 0,
  playTime: window.baseInfo.play_time
}

// 记录实际播放时间
function setLocalLearnTime(isPause) {
  // 如果是第一次记录
  if (!state.learnStartTime) {
    state.learnStartTime = new Date().getTime()
  } else {
    const learnNowTime = state.isPauseTime
      ? state.learnStartTime
      : new Date().getTime()

    // 更新总学习时长(秒)
    state.learnTotalTime = parseInt(
      state.learnTotalTime + (learnNowTime - state.learnStartTime) / 1000
    )

    // 更新起始计算时间
    state.learnStartTime = new Date().getTime()
  }

  state.isPauseTime = !!isPause // 如果暂停了就停止计时

  console.log('设置学习时长统计：', state.learnTotalTime, state.learnStartTime)
}

export const postTime = function(isPause = false) {
  setLocalLearnTime(isPause) // 每次更新记录的学习时长

  console.log('--postTime--')
  const baseInfo = window.baseInfo
  if (+baseInfo.user_id <= 0) {
    console.log('未登录，不保存进度')
    return
  }

  const player = this
  if (player) {
    var _currentTime = player.getCurrentTime()
  }
  const playTime = (state.playTime = +_currentTime || state.playTime)

  console.log('learningTime 学习时长：', state.learnTotalTime)

  const url =
    `${APIS.updatePlayTime}` +
    `?keshi_id=${
      baseInfo.keshi_id
    }&play_time=${playTime}&learningTime=${state.learnTotalTime || 0}`
  return $http.get(url)
}

var _loadTimeoutTimer
export const clearLoadingTimeout = () => window.clearTimeout(_loadTimeoutTimer)
export const onLoadingTimeout = function(timeout) {
  const player = this
  const _timeount = +timeout * 1000
  const _currentTime = player.getCurrentTime()

  return (
    clearTimeout(_loadTimeoutTimer),
    (_loadTimeoutTimer = setTimeout(() => {
      var playTime = player.getCurrentTime()
      const isTimeout = playTime - _currentTime === 0

      if (isTimeout) {
        statMonitor({
          logType: 'info',
          title: '学院-错误日志',
          message: JSON.stringify({
            keshi_id: window.baseInfo.keshi_id,
            session_id: window.baseInfo.user_id,
            卡顿时间点: _currentTime
          }),
          level: 'error',
          url: location.href,
          payParameters: JSON.stringify({}),
          code: '',
          UA: navigator.userAgent,
          remark: '课程播放页面 - 播放缓冲超过5秒'
        })
        // return onLoadingTimeout.call(player, timeout)
      }
    }, _timeount))
  )
}

export const playStat = () => {
  console.log('maidian')

  const baseInfo = window.baseInfo
  const classify =
    +baseInfo.is_experience === 1
      ? '免费试听'
      : +baseInfo.is_free === 1
      ? '免费课程'
      : '付费课程'

  window.yxl.stat.send({
    name: '课程-播放页「播放按钮」点击',
    properties: {
      课程类型: classify,
      课程名称: baseInfo.lesson_title
    }
  })
}

export const onError = e => {
  const info = window.baseInfo
  statMonitor({
    logType: 'info',
    title: '学院-错误日志',
    message: JSON.stringify({
      keshi_id: info.keshi_id,
      session_id: info.user_id,
      错误信息: e
    }),
    level: 'error',
    url: location.href,
    payParameters: JSON.stringify({}),
    code: '',
    UA: navigator.userAgent,
    remark: '课程播放页面 - 播放错误'
  })
}

export const serverError = e => {
  console.log('serverError 业务逻辑错误', e)

  statMonitor({
    logType: 'info',
    title: '学院-错误日志',
    message: JSON.stringify({
      keshi_id: window.baseInfo.keshi_id,
      session_id: window.baseInfo.user_id,
      错误信息: e
    }),
    level: 'error',
    url: location.href,
    payParameters: JSON.stringify({}),
    code: '',
    UA: navigator.userAgent,
    remark: '课程播放页面 - 业务逻辑错误'
  })
}

var _timingEecords
export const closeTimingEecords = () => window.clearTimeout(_timingEecords)
export const startTimingEecords = function(immediate) {
  const self = this
  if (_timingEecords) {
    closeTimingEecords()
  }
  immediate && postTime.call(self)
  _timingEecords = setTimeout(startTimingEecords.bind(self, true), 60000)
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/playerEvent.js